/**
 * Centralized Application Logger for SynexOS / InnovateBooks.
 * 
 * Provides a unified console logging abstraction for frontend application code.
 * Fails closed: Emits console output ONLY when NODE_ENV is explicitly 'development'.
 * In production or unknown environments, all logger operations are silent no-ops.
 */

const isDevelopment = () =>
  typeof process !== "undefined" &&
  process.env.NODE_ENV === "development";

export const logger = {
  debug: (...args) => {
    if (isDevelopment()) {
      console.debug(...args);
    }
  },
  log: (...args) => {
    if (isDevelopment()) {
      console.log(...args);
    }
  },
  info: (...args) => {
    if (isDevelopment()) {
      console.info(...args);
    }
  },
  warn: (...args) => {
    if (isDevelopment()) {
      console.warn(...args);
    }
  },
  error: (...args) => {
    if (isDevelopment()) {
      console.error(...args);
    }
  },
};

export default logger;
